<template>
    <div class="personalMain">
      <p class="current">当前位置：<span>个人中心</span><i class="el-icon-arrow-right"></i><span>我的收藏</span></p>
      <div class="personal-box">
        <personalMenu></personalMenu>
        <div class="MainInfo">
            <p class="currTitle">我的收藏</p>
            <div v-for="item in favList" :key="item.id" class="bookingItems">
               <div class="bookingInfo">
                    <div class="imgBox">
                        <img :src="item.file_url" style="width: 100%;height: 100%; object-fit: cover;" alt="">
                    </div>
                    <div style="overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2; -webkit-box-orient: vertical;width: calc(100% - 200px);">
                        <p>{{ item.title }}</p>
                        <span>时间：{{ item.create_time }}</span>
                    </div>
               </div>
               <div class="bookingButton">
                    <el-button round @click="HandleInfo(item.xid)">详情</el-button>
                    <el-button round @click="deleteFav(item)">取消</el-button>
               </div>
            </div>
            
            <div v-if="favList == ''" class="teamsNull">
                <p>亲，未找到记录~</p>
            </div>
            <div style="text-align: right;">
                <el-pagination
                    :hide-on-single-page="hideOnSinglePage"
                    :page-size="10"
                    :pager-count="widthNew?11:5"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import personalMenu from './index.vue'
export default {
    data(){
        return{
            favList: [],
            total: 0,
            hideOnSinglePage: true,
            widthNew: false
        }
    },
    components:{
        personalMenu
    },
    methods: {
        listByUser(data){
            this.$store.dispatch('personal/favListByUser',data)
            .then(res => {
            if(res.ok){
                this.total = res.data.total

                if(this.total <= 10){
                    this.hideOnSinglePage = true
                }else{
                    this.hideOnSinglePage = false
                }
                this.favList = res.data.items
                this.favList.forEach(item => {
                
                    const timeDate = new Date(item.create_time)
                    item.create_time = this.getDateTime(timeDate)

                });
            }
            })
        },
        getDateTime(timeDate){
            const year = timeDate.getFullYear();
            const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
            const day = timeDate.getDate().toString().padStart(2, '0');
            const hours = timeDate.getHours().toString().padStart(2, '0');
            const minutes = timeDate.getMinutes().toString().padStart(2, '0');
            const seconds = timeDate.getSeconds().toString().padStart(2, '0');
            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            return formattedDate
        },
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            let listSign = {
                pageNum: val,
                pageSize: 10
            }
            this.listByUser(listSign)
        },
        HandleInfo(val){
            const {href} = this.$router.resolve({
                path: '/detailPages',
                query: {
                    key: val,
                    currentName: '我的收藏'
                }
            })
            window.open(href, '_blank')
        },
        deleteFav(item){
            let data = {
                b_type:"article",
                id: item.id,
                xid: item.xid
            }

            this.$store.dispatch('personal/deleteByUserFav',data)
                .then(res => {
                    if(res.ok){
                        this.$notify({
                            title: '提示',
                            message: '取消成功',
                            type: 'success'
                        })
                        let listFav = {
                            pageNum: 1,
                            pageSize: 10
                        }
                        this.listByUser(listFav)
                    }
                })
        }
    
    },
    mounted(){
        
       
    },
    created(){
        localStorage.setItem('active','2-10')
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        let listFav = {
            pageNum: 1,
            pageSize: 10
        }
        this.listByUser(listFav)
    }
}
</script>

<style>
@import url(../../css/personal.css);
</style>

<style scoped lang="scss">
.bookingItems{
    margin: 10px 0 40px 0;
    padding: 10px 10px 25px 10px;
    font-size: 20px;
    border-bottom: 0.5px solid #f2f2f2;
    .bookingInfo{
        display: flex;
        justify-content: flex-start;
        // align-items: center;
        .imgBox{
            width: 150px;
            height: 100px;
            border: 1px solid #f2f2f2;
            border-radius: 10px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            margin-right: 20px;
        }
        p{
            width: 100%;
            line-height: 30px;
            // overflow: hidden;
            // display: -webkit-box;
            // -webkit-line-clamp: 2;
            // -webkit-box-orient: vertical;
            margin-bottom: 20px;

            // overflow: hidden;
            // white-space: nowrap;
            // text-overflow: ellipsis;
        }
        span{
            font-size: 16px;
            color: #666666;
        }
    }

    .bookingButton{
        margin-top: 10px;
        text-align: right;
    }
   
}

.teamsNull{
    font-size: 18px;
    color: #666666;
    text-align: center;
    margin-top: 40px;
}

  </style>